import { useState } from "react";
import { faqs } from "@/mocks/gossip";

const schema = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-28 bg-background-50 py-12 md:py-16">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: schema }} />
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <span className="text-xs font-bold uppercase tracking-widest text-secondary-700">FAQ</span>
            <h2 className="mt-2 font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
              关于吃瓜糖心，你想问的
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              关于内容尺度、深扒标准、投稿流程与如何理性吃瓜，我们都把话说在前面。如果还有没问到的，随时到下方投稿表单找我们。
            </p>
            <div className="mt-6 rounded-2xl border border-secondary-200 bg-secondary-100/60 p-5">
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-secondary-500 text-background-50">
                  <i className="ri-chat-smile-3-line h-6 w-6"></i>
                </span>
                <div>
                  <p className="text-sm font-bold text-foreground-950">还是想找我们聊聊？</p>
                  <a href="#contact" className="text-sm font-semibold text-secondary-800 hover:text-secondary-900">
                    前往投稿与联系 →
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="space-y-3">
              {faqs.map((f, i) => {
                const open = openIdx === i;
                return (
                  <div key={f.q} className={`rounded-2xl border transition-colors ${open ? "border-primary-200 bg-primary-100/40" : "border-background-200 bg-background-100/50"}`}>
                    <button
                      type="button"
                      onClick={() => setOpenIdx(open ? null : i)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                      aria-expanded={open}
                    >
                      <span className={`text-sm font-semibold md:text-base ${open ? "text-primary-800" : "text-foreground-900"}`}>
                        {f.q}
                      </span>
                      <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all ${open ? "rotate-180 bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"}`}>
                        <i className="ri-arrow-down-s-line h-5 w-5"></i>
                      </span>
                    </button>
                    {open && (
                      <div className="px-5 pb-5">
                        <p className="border-l-2 border-primary-200 pl-4 text-sm leading-7 text-foreground-700">{f.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}